var indentation_default = {
  "indentZero": "MaBN2",
  "indentOne": "_4MaDt",
  "indentTwo": "B1xCO",
  "indentThree": "KMQ82",
  "indentFour": "FM4B9",
  "indentFive": "JEWDJ",
  "indentSix": "_6uuD1"
};
export {
  indentation_default as default
};
//# sourceMappingURL=indentation-scss.js.map
